export default "__VITE_ASSET__a2f21d6e__"